const en = {
    organization:"Organization",
    year:"Year",
    months:"Month",
    days:"Day",
    assessment:"Assessment",
    assessments:"Self-Assessment",
    self:"self",
    subordinate:"Subordinate-Assessment",

    staffID:"Staff ID",
    department:"Department",
    status:"Status",

    fullname:"FirstName-LastName",

    firstName:"FirstName",
    lastName:"LastName",
    position:"Position",
    remark:"Remark",
    startDate:"Start Date",
    yearsOfService:"Years of Service",
    staffTypes:"Staff types",
    competencyLevel:"Competency Level",

    reportStatus:"Assessment Status by Department",
    reportCc:"Core Competency Assessment Summary by Each CC",
    reportCompetency:"Core Competency Assessment Summary by Department ",


    save:"Save",
    send:"Send",
    unsend:"UnSend",
    reject:"Reject"


}
export default en
